/**
 * The device ID is a unique ID, that contains two parts, a timestamp and the project ID.
 * It will identify the user within the socket server and prevents simultaneous usage of a single business user account
 * on different devices or browsers. If a business user authenticates at the socket server, the socket server emits an
 * event to all socket clients of this business user including the device ID in the payload. If the device ID doesn't
 * match the local one, the business user will be logged out and only the lats device that logged in, will remain
 * logged in.
 */
export const LOCAL_STORAGE_DEVICE_ID_KEY = 'UPDATE_STREAM_deviceId';
export const updateDeviceIdInStorage = (id) => localStorage.setItem(LOCAL_STORAGE_DEVICE_ID_KEY, id);
export const getDeviceIdFromStorage = () => localStorage.getItem(LOCAL_STORAGE_DEVICE_ID_KEY);
export const removeDeviceIdFromStorage = () => localStorage.removeItem(LOCAL_STORAGE_DEVICE_ID_KEY);
export const getTimestampFromDeviceId = (deviceId) => (deviceId === null || deviceId === void 0 ? void 0 : deviceId.split('_')[0]) || Date.now().toString();
export const getChannelIdFromDeviceId = (deviceId) => deviceId === null || deviceId === void 0 ? void 0 : deviceId.split('_')[1];
/**
 * @param {number} channelId
 * @return {string|*}
 */
export const getDeviceId = (channelId) => {
    const deviceIdFromStorage = getDeviceIdFromStorage();
    let deviceId = '';
    if (deviceIdFromStorage) {
        // return device id from storage if it is from this channel
        if (deviceIdFromStorage.endsWith(`_${channelId}`)) {
            return deviceIdFromStorage;
        }
        // otherwise create new device ID but use the previously used identifier
        deviceId = `${getTimestampFromDeviceId(deviceIdFromStorage)}_${channelId}`;
    }
    else {
        deviceId = `${Date.now().toString()}_${channelId}`;
    }
    // update device ID in storage
    updateDeviceIdInStorage(deviceId);
    return deviceId;
};
